module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dundun-bargain-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "countdown",
    attrs: {
      "id": "countdown"
    }
  }, [_c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(String(_vm.h).length >= 2 ? _vm.h : '0' + _vm.h))]), _vm._v(" "), _c('span', {
    staticClass: "minutes"
  }, [_vm._v(_vm._s(String(_vm.m).length >= 2 ? _vm.m : '0' + _vm.m))]), _vm._v(" "), _c('span', {
    staticClass: "seconds"
  }, [_vm._v(_vm._s(String(_vm.s).length >= 2 ? _vm.s : '0' + _vm.s))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/gdo-bargain.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-474edfa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/buy-limit/title.vue
// module id = 1595
// module chunks = 1